export default __webpack_public_path__ + "static/media/kangoo-small.343ab6de.jpg";